import { j as e } from "../../jsx-runtime-ClSzPYp4.js";
import { useState as d, useEffect as x } from "react";
import { ThemeProvider as j } from "styled-components";
const T = ({ useBrandSelector: i, themeLoader: h, defaultBrand: l, defaultTheme: r, LoadingIndicator: m }) => ({ children: f }) => {
  const t = i(), [u, p] = d(r), [n, c] = d(!1), s = (o) => {
    p(o), c(!0);
  };
  return x(() => {
    const o = async () => {
      try {
        const { default: a } = await h(t);
        s(a);
      } catch (a) {
        console.error(a), s(r);
      }
    };
    t !== l && t !== null ? (c(!1), o()) : s(r);
  }, [
    t
  ]), /* @__PURE__ */ e.jsxs(e.Fragment, {
    children: [
      !n && m && /* @__PURE__ */ e.jsx(m, {}),
      n && /* @__PURE__ */ e.jsx(e.Fragment, {
        children: /* @__PURE__ */ e.jsx(j, {
          theme: u,
          children: f
        })
      })
    ]
  });
};
export {
  T as default
};
